import React from 'react';
import { Outlet } from 'react-router-dom';
import MyNavbar from './Navbar/Navbar';
import MyFooter from './Footer/Footer';
import CartDrawer from '../common/cart/cartDrawer/CartDrawer';

export default function Layout() {
  return (
    <div className="app">
      <MyNavbar />
      <div className="content">
        <Outlet />
      </div>
      <MyFooter />
      <CartDrawer />
    </div>
  );
}
